/**
 * The category of a {@link Marker}. It controls the displayed icon.
 */
export enum SbbMarkerCategory {
  NEUTRAL = 'NEUTRAL',
  INFORMATION = 'INFO',
  DELAY = 'DELAY',
  WARNING = 'MISSED-CONNECTION',
  REPLACEMENTBUS = 'REPLACEMENTBUS',
  CONSTRUCTION = 'CONSTRUCTION',
  DISRUPTION = 'DISRUPTION',
  REGIONDISRUPTION = 'REGION-DISRUPTION',
  WALK = 'WALK',
  BICYCLE = 'BICYCLE',
  BICYCLEPARKING = 'BIKE-PROFILE-SIGN-PARKING',
  RAIL = 'ZUG',
  TRAM = 'TRAM',
  BUS = 'BUS',
  PLAIN = 'FLUGZEUG',
  BOAT = 'SCHIFF',
  METRO = 'METRO',
  COG = 'ZAHNRADBAHN',
  FUNICULAR = 'STANDSEILBAHN',
  CABLEWAY = 'LUFTSEILBAHN',
  GONDOLALIFT = 'GONDELBAHN',
  CHAIRLIFT = 'SESSELLIFT',
  SKILIFT = 'SKILIFT',
  PARKANDRAIL = 'PARK-AND-RAIL',
  CARPROFILESIGNPARKING = 'CAR-PROFILE-SIGN-PARKING',
  CUSTOM = 'CUSTOM',
}
